import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import {isEmpty} from 'lodash/lang';
import {FormErrors} from '../common';
import {SecondaryNavigation} from 'components/Navigation';
import MessageForm from './MessageForm';
import {createMessage} from 'api';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';

class MessageCreation extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };
  static propTypes = {
    schoolId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(data) {
    const {schoolId, formatErrors, addFlashMessage} = this.props;
    return createMessage({
      ...data,
      receiverRole: data.receiverRole.value,
      receiverSchoolId: schoolId ? schoolId : !isEmpty(data.receiverSchool) ? data.receiverSchool.id : null,
      receiverId: !isEmpty(data.receiver) ? data.receiver.id : null,
      receiverIds: !isEmpty(data.receivers) ? data.receivers.map(({id}) => id) : null,
      receiverClassroomIds: !isEmpty(data.receiverClassrooms) ? data.receiverClassrooms.map(({id}) => id) : null,
      level: !isEmpty(data.level) ? data.level.value : null,
      state: !isEmpty(data.state) ? data.state.value : null,
      country: !isEmpty(data.country) ? data.country.value : null,
    })
      .then(() => {
        addFlashMessage('Message has been successfully created!', 'success');
        this.context.router.history.push('/messages/sent');
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {errors} = this.state;
    const {schoolId, user} = this.props;
    return (
      <React.Fragment>
        <SecondaryNavigation
          tabs={[
            {url: '/messages/create', label: 'Create Messages', isActive: true},
            {url: '/messages/received', label: 'Messages Received', isActive: false},
            {url: '/messages/sent', label: 'Messages Sent', isActive: false},
          ]}
        />
        <div className="container content-box">
          <Panel>
            <h3 className="section-header">
              <div className="section-title">Create New Message</div>
            </h3>
            <FormErrors errors={errors} />
            <MessageForm schoolId={schoolId} onSubmit={this.handleFormSubmit} />
          </Panel>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {account} = state;
  const user = account.get('user').toJS();
  const schoolId = !isEmpty(user.activeSchool) ? user.activeSchool.id : undefined;
  return {
    schoolId,
    user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MessageCreation);
